export default __webpack_public_path__ + "static/media/Group 8157.8fd6f8b4.png";